export default error => ({ error: { message: typeof error === 'object' ? error.message : String(error) } });
